import { EsuraApiConnectionPropertiesType } from "../types/SettingsType";
import {  delEmptyBody, get, post, put,  } from "../utils/axios-config"; 
import { ESURA_API_CONNECTION_PROPERTIES } from "../utils/constants";

export const createEsuraApiConnectionProperties = async (data: EsuraApiConnectionPropertiesType) => {
  return await post<EsuraApiConnectionPropertiesType, string>(ESURA_API_CONNECTION_PROPERTIES, data);
};

export const updateEsuraApiConnectionProperties = async (data: EsuraApiConnectionPropertiesType) => {
  return await put<EsuraApiConnectionPropertiesType, string>(ESURA_API_CONNECTION_PROPERTIES, data);
};

export const getEsuraApiConnectionProperties = async () => {
  return await get<EsuraApiConnectionPropertiesType>(ESURA_API_CONNECTION_PROPERTIES);
};

export const deleteEsuraApiConnectionProperties = async (id: string) => {
  return await delEmptyBody<any>(`${ESURA_API_CONNECTION_PROPERTIES}/${id}`);

};
